import { atom } from 'recoil';
import { refillSidebarVisibleStateKey } from '../constants';

export const refillSidebarVisibleState = atom<boolean>({
  key: refillSidebarVisibleStateKey,
  default: false,
});
